import { TileData } from '@/core/components/tiles/types';

enum ClientSettingTypeEnum {
    // Пользователь контекста
    ContextUser = 0,
    // Пользователь типа контекста
    UserOfContextType = 1,
    // Роль контекста
    ContextRole = 2,
    // Контекст
    Context = 3,
    // Тип контекста
    ContextType = 4,
    // Настройки по умолчанию
    Default = 5,
}

enum SortingFieldEnum {
    Count = 0,
    Volume = 1,
    Weight = 2,
}

interface OffsetsBlockSettings {
    timeOffset?: number;
    alignTimeOffset?: number;
    historyHorizon?: number;
    regularExpressionExternalData?: string;
    formatDate?: string;
    formatTime?: string;
    formatWeight?: string;
    formatVolume?: string;
    formatArea?: string;
    formatCurrency?: string;
    formatNumber?: string;
    siteGroups?: string;
    startShiftTime?: string;
    productPackCount?: number;
    orderingField?: SortingFieldEnum;
    mapObjectIcons?: string;
    siteIconSizeMultiplier?: number;
    urlMap?: string;
}

interface ClientSettings {
    enableNotifications?: boolean;
    enableGroupNotifications?: boolean;
    saveTileState?: boolean;
    colorIndication?: boolean;
    enableTableColumnHeaderWordWrap?: boolean;
    autoReconnect?: boolean;
}

interface ContextSettings {
    global: ClientSettings & OffsetsBlockSettings & { [key: string]: string };
    tableLayouts: { [key: string]: number };
    settingsTypes: { [key: string]: ClientSettingTypeEnum };
    tileData: TileData[];
    indicators: string[];
    server: ServerSettings;
}

interface ServerSettings {
    helpLink?: string;
    version?: string;
}

export {
    ClientSettingTypeEnum,
    SortingFieldEnum,
    OffsetsBlockSettings,
    ClientSettings,
    ContextSettings,
    ServerSettings
};
